import React from 'react'
import { CallRounded } from '@mui/icons-material'

import './callToAction.css'

const CallToAction = () => {
  return (
    <>
        <div className='call-to-action-wrapper'>
            <div className='call-to-action-container'>
                <div className="call-to-action-detail">
                    <p className="call-to-action-title">1907 wilson Lake Ct, Wylie TX 75098-4814, US.</p>
                    <a href="tel:+14693262931" className="call-to-action-link">
                        <CallRounded className="call-to-action-btn" />
                        Call Today: 
                        <span className='call-to-action-link-title'> +1-469-326-2931</span>
                    </a>
                </div>
            </div>
        </div>
    </>
  )
}

export default CallToAction